/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Custom js files should be added to the src/javascripts folder and imported here
// import '../src/javascripts/filename.js';

import "controllers"
import CookieEuBanner from "cookies-eu-banner"

(window as any).CookieEuBanner = CookieEuBanner;
